import { render, staticRenderFns } from "./editAnnouncement.vue?vue&type=template&id=ef92bade&scoped=true"
import script from "./editAnnouncement.vue?vue&type=script&lang=js"
export * from "./editAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef92bade",
  null
  
)

export default component.exports